import React, { useState, useEffect } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import mediaImg from "../../assets/mediaenter.png";

import { FaRobot, FaTv } from "react-icons/fa";

const responsiveStyles = `
  .med-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .med-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .med-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .med-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .med-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .med-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 0;
  }

  .med-header-right-deco-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .med-header-right-deco-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .med-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .med-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .med-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .med-image-wrap {
    flex: 1;
  }

  .med-image-wrap img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .med-accordion {
    flex: 1.2;
  }

  .med-accordion-item {
    margin-bottom: 18px;
  }

  .med-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .med-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .med-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet: 768px – 1024px ── */
  @media (max-width: 1024px) {
    .med-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .med-header-badge {
      width: auto;
      font-size: 14px;
      padding: 10px 16px;
    }

    .med-header-title h2 {
      font-size: 24px;
    }
  }

  /* ── Mobile: ≤ 767px ── */
  @media (max-width: 767px) {
    .med-header {
      flex-direction: column;
      height: auto;
    }

    .med-header-left {
      flex: none;
      padding: 16px;
      min-height: 80px;
    }

    .med-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
      gap: 8px;
    }

    .med-header-right {
      flex: none;
      padding: 16px;
      min-height: 70px;
    }

    .med-header-right-deco-left,
    .med-header-right-deco-right {
      width: 50px;
    }

    .med-header-title h2 {
      font-size: 20px;
    }

    .med-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .med-image-wrap {
      width: 100%;
    }

    .med-image-wrap img {
      max-width: 100%;
    }

    .med-accordion {
      width: 100%;
    }

    .med-accordion-header {
      padding: 10px 16px;
      font-size: 14px;
    }
  }

  /* ── Very small phones: ≤ 400px ── */
  @media (max-width: 400px) {
    .med-header-badge {
      font-size: 12px;
      padding: 8px 10px;
    }

    .med-header-title h2 {
      font-size: 17px;
    }

    .med-accordion-header {
      font-size: 13px;
      padding: 8px 12px;
    }

    .med-accordion-body {
      padding: 14px;
      font-size: 13px;
    }
  }
`;

function MediaEntertainmentPage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const styleId = "med-responsive-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.innerHTML = responsiveStyles;
      document.head.appendChild(tag);
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Content Creation",
      content:
        "Automate organized news content such as, earnings reports, sports competitions, and advertising, by using RPA along with AI algorithms."
    },
    {
      title: "2.Content Verification",
      content:
        "Robots to validate documents, contracts, and machine-written content, highlight spelling errors, for accurateness and correctness."
    },
    {
      title: "3.Content Discovery",
      content:
        "RPA helps to Track online news and competitor websites to advance more ideas for content."
    },
    {
      title: "4.Forms Processing",
      content:
        "In the media industry many forms need to be processed on daily basis, which include:-License requests, Copywriter requests, Synchronization forms, Lyrics processing and submission"
    },
    {
      title: "5.Data Migration",
      content:
        "RPA can be used as the adhesive between your systems, to automatically migrate data, saving valuable time of the team."
    }
  ];

  return (
    <div>

      {/* ===== HEADER ===== */}
      <div className="med-header">
        {/* LEFT */}
        <div
          className="med-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="med-header-overlay" />

          <div className="med-header-badge">
            <div className="med-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="med-header-right">
          <div className="med-header-right-deco-left" />
          <div className="med-header-right-deco-right" />

          <div className="med-header-title">
            <FaTv style={{ fontSize: "32px", color: "#2fb7a4" }} />

            <h2>Media & Entertainment</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="med-main">
        {/* IMAGE */}
        <div className="med-image-wrap">
          <img src={mediaImg} alt="Media and entertainment" />
        </div>

        {/* ACCORDION */}
        <div className="med-accordion">
          {data.map((item, i) => (
            <div key={i} className="med-accordion-item">
              <div
                className="med-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="med-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="med-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MediaEntertainmentPage;
